export default __webpack_public_path__ + "static/media/auteur4.96b3fa71.png";